import { Wrapper } from '@american-autonomy/ag-ui';

import SingleSelectPanel from 'components/SingleSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { ENTITY_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Item, Props } from './types';

const FarmSelectPanelField: FunctionComponent<Props> = ({
    className = '',
    clientId,
    onChange,
    onClose,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { farmItems, handleAsyncFilter, hasNextPage, isLoading, noItemsText, onNextPage } =
        useData(clientId);

    const handleClick = (farm: Item) => {
        onChange(farm);
        onClose?.(farm);
    };

    return (
        <Wrapper className={className} testId={testId}>
            <SingleSelectPanel
                entityType={ENTITY_TYPE}
                hasNextPage={hasNextPage}
                isLoading={isLoading}
                itemSelected={value}
                items={farmItems}
                label={SEARCH}
                noItemsFoundText={noItemsText}
                onFilter={handleAsyncFilter}
                onNextPage={onNextPage}
                onSelected={handleClick}
            />
        </Wrapper>
    );
};

export default FarmSelectPanelField;
